import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import wordmark from '../assets/images/AbbisWayWordmark.png';
/**
 * AbbisWayWordmark.png is 1200x249: the "Abbi's Way" lettering and green
 * figure from the web logo (AbbisWayLogo.svg), with the tagline, frame and
 * white field removed. Transparent background, trimmed tight.
 */
export const WORDMARK_ASPECT_RATIO = 1200 / 249;
/**
 * Fills the width of its container (up to `maxWidth`) at the logo's aspect ratio.
 * Used full-width on Sign in and beside the Settings button in the Home header.
 */
export const AbbisWayWordmark = ({ maxWidth = 420, style }) => (<View style={[styles.wrap, { maxWidth }, style]} accessible accessibilityRole="header" accessibilityLabel="Abbi's Way">
    <Image source={wordmark} style={styles.image} resizeMode="contain"/>
  </View>);
const styles = StyleSheet.create({
    wrap: {
        width: '100%',
        alignSelf: 'center',
    },
    image: {
        width: '100%',
        height: undefined,
        aspectRatio: WORDMARK_ASPECT_RATIO,
    },
});
